module.exports = __webpack_public_path__ + "img/doc_publish.df7c74e6.gif";